import { Component, ElementRef, Input } from '@angular/core';
import { FormPopupComponent } from '../form-popup/form-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'calsoft-button-row-header',
  templateUrl: './button-row-header.component.html',
  styleUrls: ['./button-row-header.component.scss']
})
export class ButtonRowHeaderComponent {
  @Input() item: any;
  @Input() data: any;
  @Input() value: string;
  ngOnInit() {
    
  }

  constructor(
    public dialog: MatDialog,
    private elementRef: ElementRef,
    private commonService:CommonService
  ){

  }




callToFunction(type,value){

  this.commonService.navigateButton(type,value)
  

}

}
